
export enum ReplOrderStatus {
  Ordered = 1,
  ReadyToOrder = 0
}

export const ReplOrderStatusLabels = {
    [ReplOrderStatus.Ordered]: 'Ordered',
    [ReplOrderStatus.ReadyToOrder]: 'Ready To Order',
}